<template>
  <div>
    <!-- Reutilizar componente de Retenciones de SpentPayment -->
    <RetencionesSpentPayment
      :item="item"
      :isViewModal="isViewModal"
      :open="open"
      :validator="validator"
      :receiver="receiver"
      :loading_calc_retenciones="loading_calc_retenciones"
      :openFromPaymentOrder="true"
      @setLoadingCalcRetenciones="handleSetLoadingCalcRetenciones"
    />
  </div>
</template>

<script>
import RetencionesSpentPayment from "@/views/Spents/PaymentComponent/Retenciones.vue";

export default {
  components: {
    RetencionesSpentPayment
  },
  props: {
    item: Object,
    isViewModal: Boolean,
    open: Boolean,
    validator: Object,
    loading_calc_retenciones: Boolean,
    receiver: { type: Object, default: null }
  },
  methods: {
    handleSetLoadingCalcRetenciones(value) {
      // Propagar el evento hacia el componente padre
      this.$emit('setLoadingCalcRetenciones', value);
    }
  }
};
</script>
